export { getEmployees, bindClient } from "./legacy";
export { hierarchyApi, useGetEmployeesQuery } from "./rtk";
